import { render, staticRenderFns } from "./PopupDetails.vue?vue&type=template&id=3765169b&"
import script from "./PopupDetails.vue?vue&type=script&lang=js&"
export * from "./PopupDetails.vue?vue&type=script&lang=js&"
import style0 from "./PopupDetails.vue?vue&type=style&index=0&id=3765169b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports